import { FingerprintIcon as Fingerprint, FileIcon as FileIcon, CpuIcon as Cpu, WarningIcon as Warning } from "@phosphor-icons/react";
import { ORIGIN_LABEL, SIGNAL_LABEL, STALE_CLASS, STALE_LABEL, objectLabel, staleTransition, stateClass, stateLabel } from "@/lib/dispositionConstants";

/** Table of disposition rows; click a row to open its detail panel. */
export default function DispositionTable({ items, selectedId, onSelect }) {
  if (!items || items.length === 0) {
    return (
      <div className="p-12 text-center text-sm text-[var(--ml-text-secondary)]" data-testid="dispositions-empty">
        No dispositions match these filters.
      </div>
    );
  }
  return (
    <table className="w-full text-sm" data-testid="dispositions-table">
      <thead>
        <tr className="border-b border-[var(--ml-border)] bg-[var(--ml-surface)]">
          {["object", "treatment", "disposition", "state", "signal", "evidence", "rationale"].map((h) => (
            <th key={h} className="px-3 py-2 text-left ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)] whitespace-nowrap">
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {items.map((d, i) => {
          const selected = d.id === selectedId;
          const Icon = d.object_kind === "program" ? Cpu : FileIcon;
          return (
            <tr
              key={d.id}
              onClick={() => onSelect(d.id)}
              data-testid={`disposition-row-${d.id}`}
              className={`border-b border-[var(--ml-border)] last:border-b-0 cursor-pointer hover:bg-[var(--ml-primary)]/[0.04] ${
                selected ? "bg-[var(--ml-primary)]/[0.07]" : i % 2 ? "bg-[var(--ml-surface)]/30" : ""
              }`}
            >
              <td className="px-3 py-2 ml-mono text-xs font-semibold whitespace-nowrap">
                <span className="inline-flex items-center gap-1.5">
                  <Icon size={13} className="text-[var(--ml-text-secondary)]" />
                  {objectLabel(d)}
                </span>
                <div className="text-[10px] font-normal text-[var(--ml-text-secondary)]">{d.object_kind}</div>
              </td>
              <td className="px-3 py-2 text-xs">{d.technical_treatment || <span className="text-[var(--ml-text-secondary)]">—</span>}</td>
              <td className="px-3 py-2 text-xs">{d.migration_disposition || <span className="text-[var(--ml-text-secondary)]">—</span>}</td>
              <td className="px-3 py-2 whitespace-nowrap">
                <span className={`ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border ${stateClass(d.state)}`} data-testid={`state-pill-${d.id}`}>
                  {stateLabel(d.state)}
                </span>
                {d.stale && (
                  <span className={`ml-1 ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border inline-flex items-center gap-1 ${STALE_CLASS}`}
                        title={d.stale_reason || ""} data-testid={`stale-pill-${d.id}`}>
                    <Warning size={10} weight="bold" /> {STALE_LABEL}
                  </span>
                )}
              </td>
              <td className="px-3 py-2 text-xs whitespace-nowrap">
                {d.signal ? SIGNAL_LABEL[d.signal] || d.signal : <span className="text-[var(--ml-text-secondary)]">{ORIGIN_LABEL[d.origin] || d.origin}</span>}
                {d.stale && (
                  <div className="text-[10px] text-[#8a3800]" data-testid={`stale-transition-${d.id}`}>{staleTransition(d)}</div>
                )}
              </td>
              <td className="px-3 py-2 text-xs whitespace-nowrap">
                <span className="inline-flex items-center gap-1 text-[var(--ml-text-secondary)]" title={`${d.evidence_refs.length} import batch(es)`}>
                  <Fingerprint size={12} /> {d.evidence_refs.length}
                </span>
              </td>
              <td className="px-3 py-2 text-xs max-w-[360px] truncate text-[var(--ml-text-secondary)]" title={d.rationale || ""}>
                {d.rationale || "—"}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
